module.exports = __webpack_public_path__ + "img/brick-image.9c42b60a.jpg";